import React from "react";
import googleLogo from "@/assets/auth/google-logo.svg";
import ThirdPartyServiceButton, {
  ThirdPartyButtonProps,
} from "@/components/pages/auth/components/third-party-service-button";

const GoogleButton = ({
  title,
  callbackUrl,
  isDisabled,
}: ThirdPartyButtonProps) => {
  return (
    <ThirdPartyServiceButton
      title={title}
      provider={"google"}
      logo={googleLogo}
      callbackUrl={callbackUrl}
      isDisabled={isDisabled}
    />
  );
};

export default GoogleButton;
